import type { SvgIconComponent } from "@mui/icons-material";

import { EventTagEnum, glyphByEventTagEnum } from "~/types/tag";

type TabBadge = null | SvgIconComponent;

export const badgeByTab: Record<EventTagEnum, TabBadge> = {
  [EventTagEnum.ALL]: null,
  [EventTagEnum.NEW]: null,
  [EventTagEnum.ENDING_SOON]: null,
  [EventTagEnum.BREAKING]: glyphByEventTagEnum[
    EventTagEnum.BREAKING
  ] as SvgIconComponent,
  [EventTagEnum.TRENDING]: glyphByEventTagEnum[
    EventTagEnum.TRENDING
  ] as SvgIconComponent,
};
